export default () => ({
    data: null,
    edited: false
})